export { CorporationPage as default } from '@/components/pages/Contact/Corporation/index'
